const getApiBaseUrl = () => {
  if (typeof window !== 'undefined' && window.location) {
    if (window.__API_BASE_URL__) return window.__API_BASE_URL__;
    const { protocol, hostname } = window.location;
    const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
    const envUrl = process.env.REACT_APP_API_URL;
    if (envUrl) {
      if (!isLocal && hostname.endsWith('tryonebest.com')) {
        return `${protocol}//books.tryonebest.com`;
      }
      return envUrl;
    }
    if (isLocal) {
      const apiPort = process.env.REACT_APP_API_PORT || '8000';
      return `${protocol}//${hostname}:${apiPort}`;
    }
    if (hostname.endsWith('tryonebest.com')) {
      return `${protocol}//books.tryonebest.com`;
    }
    return `${protocol}//${hostname}`;
  }

  const envUrl = process.env.REACT_APP_API_URL;
  if (envUrl) return envUrl;
  return '';
};

// 通用请求函数
async function request(endpoint, options = {}) {
  // 移除末尾斜杠避免307重定向
  const cleanEndpoint = endpoint.replace(/\/$/, '');
  const apiBaseUrl = getApiBaseUrl();
  const url = apiBaseUrl ? `${apiBaseUrl}${cleanEndpoint}` : cleanEndpoint;
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
    // 不携带cookie，避免CORS问题
    credentials: 'omit',
  };
  
  try {
    const response = await fetch(url, { ...defaultOptions, ...options });
    
    if (!response.ok) {
      const errorText = await response.text();
      let errorMessage = `HTTP ${response.status}`;
      try {
        const errorJson = JSON.parse(errorText);
        errorMessage = errorJson.message || errorMessage;
      } catch {
        errorMessage = errorText || errorMessage;
      }
      throw new Error(errorMessage);
    }
    
    return response.json();
  } catch (error) {
    console.error('API请求失败:', url, error);
    throw error;
  }
}

// 书籍 API
export const bookApi = {
  // 获取书籍列表
  getBooks: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const queryPart = queryString ? `?${queryString}` : '';
    return request(`/api/books${queryPart}`);
  },
  
  // 获取书籍详情
  getBook: (id) => request(`/api/books/${id}`),
  
  // 获取书籍章节列表
  getBookChapters: (id, params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const queryPart = queryString ? `?${queryString}` : '';
    return request(`/api/books/${id}/chapters${queryPart}`);
  },
  
  // 添加书籍
  addBook: (data) => request('/api/books/', {
    method: 'POST',
    body: JSON.stringify(data),
  }),
  
  // 触发抓取
  startScrape: (id) => request(`/api/books/${id}/scrape`, {
    method: 'POST',
  }),
  
  // 获取抓取进度
  getProgress: (id) => request(`/api/books/${id}/progress`),
};

// 章节 API
export const chapterApi = {
  // 获取章节详情
  getChapter: (id) => request(`/api/chapters/${id}`),
  
  // 获取章节内容
  getContent: (id) => request(`/api/chapters/${id}/content`),
};

// 网站 API
export const siteApi = {
  // 获取所有网站
  getSites: () => request('/api/sites/'),
  
  // 添加网站
  addSite: (data) => request('/api/sites/', {
    method: 'POST',
    body: JSON.stringify(data),
  }),
};

// 分类 API
export const categoryApi = {
  // 获取所有分类
  getCategories: () => request('/api/categories/'),
  
  // 获取分类及书籍数量
  getCategoriesWithCount: () => request('/api/categories/with-count'),
  
  // 获取分类详情
  getCategory: (id) => request(`/api/categories/${id}`),
  
  // 获取分类下的书籍
  getBooksByCategory: (id) => request(`/api/categories/${id}/books`),
};

// 队列 API
export const queueApi = {
  // 获取队列状态
  getStatus: () => request('/api/queue/'),
};
